import React, { Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { Link, withRouter } from 'react-router-dom';
import { Row, Col } from 'reactstrap';
import ErrorMessage from '../../components/errormessage';
import ThemedSpinner from '../../components/themed/ThemedSpinner';
import { enforceSlash } from '../../utils/helpers';
import { Table, Tr, Td, Th, Thead } from 'reactable';

@inject('superStore')
@observer
class CategoriesContainer extends React.Component {
    componentDidMount() {
        this.loadData();
    }

    async loadData() {
        await this.props.superStore.loadCategories();
    }

    render() {
        const { loadingCategories, categories, categoriesError } =
            this.props.superStore;
        const { match } = this.props;

        return loadingCategories ? (
            <ThemedSpinner />
        ) : (
            <Fragment>
                <ErrorMessage error={categoriesError} />

                <Row>
                    {categories && categories.length > 0 && (
                        <Col md="12" xs="12" className="leftMenu">
                            <Table className="table" id="table">
                                <Thead>
                                    <Th column="Name" className="">
                                        Native Name
                                    </Th>
                                    <Th column="Rules" className="">
                                        # of Rules
                                    </Th>
                                    <Th column="public" className="">
                                        Public{' '}
                                    </Th>
                                    <Th column="Subjects" className="">
                                        # of Subjects
                                    </Th>
                                    <Th column="Id" className="">
                                        Id
                                    </Th>
                                    <Th column="Order" className="">
                                        order
                                    </Th>
                                </Thead>
                                {categories.map((category, i) => (
                                    <Tr key={category.id}>
                                        <Td
                                            column={'Name'}
                                            value={category.name}
                                        >
                                            <Link
                                                to={`${enforceSlash(
                                                    match.url
                                                )}${category.id}`}
                                            >
                                                {category.name}
                                            </Link>
                                        </Td>
                                        <Td
                                            column={'Rules'}
                                            value={category.rulesCount}
                                        >
                                            {category.rulesCount}
                                        </Td>
                                        <Td
                                            column={'public'}
                                            value={category.name}
                                        >
                                            <Fragment>
                                                {category.isPublic > 0 ? (
                                                    <span
                                                        className={
                                                            'flag static-flag '
                                                        }
                                                        style={{
                                                            backgroundImage: `url(/static/img/icon-completed.png)`,
                                                        }}
                                                    >
                                                        &nbsp;
                                                    </span>
                                                ) : (
                                                    <span
                                                        className={
                                                            'flag static-flag '
                                                        }
                                                        style={{
                                                            backgroundImage: `url(/static/img/icon-close.png)`,
                                                        }}
                                                    >
                                                        &nbsp;
                                                    </span>
                                                )}
                                            </Fragment>
                                        </Td>
                                        <Td
                                            column={'Subjects'}
                                            value={category.templates}
                                        >
                                            {category.subjects}
                                        </Td>
                                        <Td
                                            column={'Id'}
                                            value={category.id}
                                            className=""
                                        >
                                            <Link
                                                to={`${enforceSlash(
                                                    match.url
                                                )}${category.id}`}
                                            >
                                                {category.id}
                                            </Link>
                                        </Td>
                                        <Td
                                            column={'Order'}
                                            value={category.order}
                                        >
                                            {category.order}
                                        </Td>
                                    </Tr>
                                ))}
                            </Table>
                        </Col>
                    )}
                </Row>
            </Fragment>
        );
    }
}

export default withRouter(CategoriesContainer);
